// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-conversation-RT_lQT{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"new-conversation": `new-conversation-RT_lQT`,
	"newConversation": `new-conversation-RT_lQT`
};
export default ___CSS_LOADER_EXPORT___;
